const DAYS = {
  mon: "Monday",
  tue: "Tuesday",
  wed: "Wednesday",
  thr: "Thursday",
  fri: "Friday",
  sat: "Saturday",
  sun: "Sunday",
};
const DAYSSELECTOR = [
  {
    text: "Monday",
    value: "mon",
  },
  {
    text: "Tuesday",
    value: "tue",
  },
  {
    text: "Wednesday",
    value: "wed",
  },
  {
    text: "Thursday",
    value: "thr",
  },
  {
    text: "Friday",
    value: "fri",
  },
  {
    text: "Saturday",
    value: "sat",
  },
  {
    text: "Sunday",
    value: "sun",
  },
];

const GROUPSTATUSES = {
  1: "Continue",
  2: "Suspended",
};

const GENDER = {
  1: "Male",
  2: "Female",
};

const WORKTYPE = {
  classes: "Class Work",
  home: "Home Work",
};

const ASSESSMENTSTATUSES = {
  1: "Open",
  2: "Joined",
};
const STUDENTINVOICESTATUSES = {
  1: "UnPaid",
  2: "Paid",
};
const TUTORINVOICESTATUSES = {
  1: "Pending",
  2: "Cleared",
};
const Countries = [
  {
    text: "Pakistan",
    value: "PK",
  },
  {
    text: "New Zealand",
    value: "NZ",
  },
  {
    text: "Afghanistan",
    value: "AF",
  },
  {
    text: "Ecuador",
    value: "EC",
  },
  {
    text: "United States",
    value: "AS",
  },
  {
    text: "United Kingdom",
    value: "GB",
  },
  {
    text: "Australia",
    value: "AU",
  },
  {
    text: "Algeria",
    value: "DZ",
  },
  {
    text: "Austria",
    value: "AT",
  },
];

export {
  DAYS,
  DAYSSELECTOR,
  GROUPSTATUSES,
  ASSESSMENTSTATUSES,
  WORKTYPE,
  STUDENTINVOICESTATUSES,
  TUTORINVOICESTATUSES,
  Countries,
};
